import { Center, Divider, GridItem, Stack } from '@chakra-ui/react';
import { Card, CardHeader, CardBody, CardFooter } from '@chakra-ui/react'


export default function InsightsPanelGridItem({ header, children, footer }) {
    return (
        <GridItem>
            <Card
                w='100%'
                h='100%'
                size='sm'
                shadow='lg'
                borderWidth='1px'
                borderRadius='lg'
                borderColor='lightgray.100'
                _hover={{ backgroundColor: "gray.50" }}
            >
                {/* Managing the header/footer size is clumsy */}
                <CardHeader
                    paddingLeft="1"
                    paddingRight="4"
                    paddingBottom="0"
                    paddingTop="2"
                    margin="2">
                    {header}
                </CardHeader>
                <CardBody paddingTop={0}>
                    {children}
                </CardBody>

                {footer && (
                    <>
                        <Divider
                            orientation="horizontal"
                            borderColor="gray.300"
                            borderWidth="1px"
                            opacity="0.5"
                            margin="0"
                        />

                        <CardFooter
                            paddingLeft="4"
                            paddingRight="4"
                            paddingBottom="0"
                            paddingTop="0"
                            margin="2"
                            justifyContent="center"
                        >
                            {footer}
                        </CardFooter>
                    </>
                )}

            </Card>
        </GridItem>
    )
}